<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div :class="creatingNewLabourRate ? 'p-5 pt-3' : 'p-3 max-h-64 overflow-y-auto'">

                <!-- New labour rate form. -->
                <div v-if="creatingNewLabourRate">
                    <div class="text-xs font-medium text-gray-400 mb-4">Create new labour rate</div>
                    <ui-form-section>
                        <ui-select-searchable
                            label="Group Name"
                            name="group_name"
                            v-model="newLabourRateForm.group_name"
                            placeholder="Horizontal, Upstands etc"
                            :error="newLabourRateForm.errors.get('group_name')"
                            :options="labourRateGroups"
                            :create-option="name => ({ value: name, label: name })"
                        ></ui-select-searchable>
                        <ui-input
                            label="Name"
                            name="name"
                            v-model="newLabourRateForm.name"
                            :error="newLabourRateForm.errors.get('name')"
                        ></ui-input>
                    </ui-form-section>
                    <div class="mt-6 flex justify-end space-x-6">
                        <ui-button-new @click.stop.prevent="creatingNewLabourRate = false">Cancel</ui-button-new>
                        <ui-button-new primary @click.stop.prevent="newLabourRateForm.submit(close)" :loading="newLabourRateForm.busy">
                            Create and Use Labour Rate
                        </ui-button-new>
                    </div>
                </div>

                <!-- Empty State. -->
                <div v-else-if="! query">
                    <div class="mb-4" v-if="current">
                      <div class="text-xs font-medium text-gray-400 mb-1">Current Labour Rate</div>
                      <p class="text-sm" v-text="current"></p>
                    </div>
                    <p class="text-gray-500 text-sm">
                        Start typing to search for labour rates...
                    </p>
                </div>

                <div v-else class="space-y-4">
                    <!-- New labour rate button. -->
                    <div>
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Create new labour rate</div>
                        <button :class="buttonClass" class="flex items-center space-x-2" @click.stop.prevent="openLabourRateForm">
                            <i class="fa fa-plus text-gray-400 text-sm"></i>
                            <div v-text="query"></div>
                        </button>
                    </div>

                    <!-- Existing labour rates. -->
                    <div>
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Select existing labour rate</div>
                        <div v-if="filteredLabourRates.length === 0" class="ml-2 text-gray-500 text-sm">
                            <div>No existing labour rate found for this unit of measure.</div>
                        </div>
                        <div v-else class="space-y-1">
                            <button
                                v-for="labourRate in filteredLabourRates"
                                :key="`labour-rate-${labourRate.id}`"
                                class="flex flex-col"
                                :class="buttonClass"
                                :title="labourRate.full_name"
                                @click.stop.prevent="selectLabourRate(labourRate, close)"
                            >
                                <div class="truncate w-full">{{ labourRate.full_name }}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import { LabourRate } from '@models'

export default {
    props: {
        uom: String,
        current: String,
        labourRates: Array,
        labourRateGroups: Array,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data () {
        return {
            query: '',
            creatingNewLabourRate: false,
            newLabourRateForm: null,
        }
    },
    computed: {
        filteredLabourRates () {
            return this.labourRates.filter(labourRate => {
                return labourRate.full_name.toLowerCase().includes(this.query.toLowerCase())
            })
        },
    },
    methods: {
        scope (dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery (query) {
            this.query = query
            if (! this.query) return
        },
        selectLabourRate (labourRate, close) {
            this.$emit('selected', labourRate)
            this.query = ''
            this.creatingNewLabourRate = false
            close()
        },
        openLabourRateForm () {
            const initialData = {
                name: this.query,
                uom: this.uom || null,
                buy_day_rate: 180.00,
                buy_hours_in_shift: 7.00,
                group_name: { value: 'Items', label: 'Items' },
                sell_day_rate: 250.00,
                sell_hours_in_shift: 7.00,
                unit_per_hour: 1,
            }

            this.newLabourRateForm = new Form(initialData, async (form, close) => {
                const labourRate = await LabourRate.create(form)
                this.$emit('created', labourRate)
                this.selectLabourRate(labourRate, close)
            }),
            this.creatingNewLabourRate = true
        },
    },
}
</script>
